import { ReactElement } from 'react';
import classNames from 'classnames/bind';

interface Buttonprops {
  buttonName: String;
  isBtnEnable: boolean;
  onSubmit: (e: any) => void;
}

const PrimaryButton = ({ buttonName, isBtnEnable, onSubmit }: Buttonprops): ReactElement => {
  let btnClass = classNames({
    'font-semibold mt-8 text-white h-12 w-10/12 py-2 px-4 rounded-lg': true,
    'bg-primary hover:bg-blue-700': isBtnEnable,
    'bg-blue-300': !isBtnEnable
  });

  return (
    <button className={btnClass} onClick={onSubmit} disabled={!isBtnEnable}>
      {buttonName}
    </button>
  );
};

export default PrimaryButton;
